<template>
<div class="chapter">
<div class="inner_page">
<p class="image" id="ch00"><a id="page_1"></a><img alt="Image" height="550" src="images/ch00.jpg" width="334"/></p>
<p class="noindent">I<span class="small">N HER LAST FEW MOMENTS OF LIFE, AS THE BLOOD</span> gushed from the knife wound in her neck, Emily Wilkins found her thoughts drifting to her mother’s death. Mrs. Wilkins had lain on her deathbed for weeks without uttering a word until finally, one day, she sat up, fixed her eyes upon Emily, and spoke.</p>
<p class="indent">“You’re a good girl, ain’t you, Em?”</p>
<p class="indent">“I try to be, Mum,” she replied.</p>
<p class="indent">“You deserve more than I’ve ever been able to get for you.”</p>
<p class="indent">“I’ve never wanted for anything,” said Emily.</p>
<p class="indent">Her mother shook her head. “You never had no schooling, <a id="page_2"></a>but you’re a bright girl. I only wish I had done better by you.”</p>
<p class="indent">“I just want you to get well,” Emily pleaded.</p>
<p class="indent">“There’s no chance of that now, my love,” said her mother. “I can hear them knocking for me.”</p>
<p class="indent">“Who?” Emily looked up. “There’s no one knocking.”</p>
<p class="indent">Mrs. Wilkins smiled weakly. “Soon I’ll have no choice but to answer. But promise me this, Em. You need to make the most of this life, because who knows what lies on the other side of that door.”</p>
<p class="indent">“What door, Mum?”</p>
<p class="indent">Her mother pointed at the blank wall beside her bed. Her smile was so full of sadness and regret that it drew yet more tears from Emily’s eyes. She wiped her face with the cloth she was using to mop her mother’s forehead.</p>
<p class="indent">Her mother coughed—a dry, throaty cough that sent a splatter of bloody phlegm into the palm of her hand— before she fell back and died, leaving Emily alone and orphaned.</p>
<p class="indent">At the time, Emily had childishly believed that this final cough was her mother’s body ejecting all its blood before dying.</p>
<p class="indent">She realized how very wrong she had been as the red liquid now gushed from her own throat. The human body contained much more than a handful of dusky blood. The murdering hands that were taking Emily’s life were covered in it.</p>
<p class="indent">The hands had appeared out of nowhere.</p>
<p class="indent"><a id="page_3"></a>The right had closed around her throat. The left, around her mouth. Emily tasted the salty sweat of her attacker as she struggled and kicked, but the hands were strong, and this clearly wasn’t the first time they had been put to such use.</p>
<p class="indent">The blade slid across her neck so smoothly, she barely felt it cut the skin. The blood gushed out like water breaking through a dam until the murderer’s right hand closed around the wound, stopping the flow.</p>
<p class="indent">“Can’t ’ave you dyin’ in the street like a dog, can we, girl?” snarled a gravelly voice. “That would never do.”</p>
<p class="indent">The hands dragged her up the dark, cobbled alleyway. She could hear knocking.</p>
<p class="indent">“Don’t you heed that, girl,” said the gruff voice. “We ain’t far now. Hang on.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00.vue?14069bee